export const emojisData = (state, emojisData) => {
  state.emojisData = emojisData;
};
